import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { StateService } from '@uirouter/angular';

@Component({
    selector: 'project-summary-org',
    template: require('./project.summary.org.html')
})
export class ProjectSummaryOrgComponent implements OnInit {
    @Input() project: any;
    @Input() details: any;
    @Input() org: any;

    constructor(
        private http: HttpClient,
        protected stateService: StateService
    ) {}

    ngOnInit() {
    }

    doResourceSearch() {
        if (!this.org) return;
        
        this.org.resourceResults = false;
        if (this.org.resourceSearch != '') {
            const unixName = this.project?.unixName || this.stateService.params?.unixName;
            const url = '/api/search/?page_num=1&page_size=10&s=wiki,docman&p=' + unixName + '&q=' + this.org.resourceSearch;
            
            this.http.get(url).subscribe(
                (result: any) => {
                    this.org.resourceResults = _.groupBy(_.get(result, 'items', []), 'section');
                },
                (failure) => {
                    console.log(failure);
                    this.org.resourceResults = [];
                }
            );
        }
    }
}
